import { color } from '@starryui10/theme/color';
import React from 'react';
import styled from 'styled-components';

export const OptionSeparator = () => {
    return (
        <li role="presentation">
            <StyledHR />
        </li>
    );
};

const StyledHR = styled.hr`
    width: 100%;
    height: 1px;
    background: ${color.Grey.G30};
    border: 0;
    padding: 0;
    margin: 0;
`;
